module.exports = __webpack_public_path__ + "static/media/Team 1- Thought Collective.b03d9c63.png";